import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
export function WhyFailedSection() {
  return <SectionWrapper alternate data-id="element-514">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-4" variants={childVariants} data-id="element-515">
        Why what you've tried failed
      </motion.h2>

      <motion.p className="font-heading text-lg text-cream-muted italic mb-10" variants={childVariants} data-id="element-516">
        (and it's not your fault)
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-8" variants={childVariants} data-id="element-517">
        Because most solutions:
      </motion.p>

      <motion.ul className="space-y-5 mb-10" variants={childVariants} data-id="element-518">
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-519">
          Focus on sleep , not middle-of-the-night wake-ups
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-520">
          <span className="mt-2 w-2 h-2 rounded-full bg-amber flex-shrink-0" data-id="element-521" />
          <div data-id="element-522">
            <span data-id="element-523">Add more decisions</span>
            <br data-id="element-524" />
            <span className="text-cream-muted" data-id="element-525">
              ("try this… or this… or this…")
            </span>
          </div>
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-526">
          <span className="mt-2 w-2 h-2 rounded-full bg-amber flex-shrink-0" data-id="element-527" />
          <div data-id="element-528">
            <span data-id="element-529">
              Ignore the anxiety loop that begins the second you think:
            </span>
            <br data-id="element-530" />
            <em className="text-amber" data-id="element-531">"Oh no."</em>
          </div>
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-532">
          Accidentally train your brain that 3am = phone time,.
        </li>
      </motion.ul>

      <motion.p className="font-heading text-xl text-teal-light font-medium leading-relaxed-plus" variants={childVariants} data-id="element-533">
        This ebook reverses that training.
      </motion.p>
    </SectionWrapper>;
}